module.exports = __webpack_public_path__ + "static/media/Karen Dennett.022f55a4.png";